import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Chart_Interface } from 'src/app/Interface/Chart_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { ChartService } from 'src/app/Service/Chart/Chart.service';

@Component({
  selector: 'app-Chart_Check',
  templateUrl: './Chart_Check.component.html',
  styleUrls: ['./Chart_Check.component.css']
})
export class Chart_CheckComponent implements OnInit {

  @Input() DataList_Chart:Array<Chart_Interface>=[]
  @Input() Selected_Chart:Array<Chart_Interface>=[]
  @Output() On_Get_Selected_Tag = new EventEmitter<Array<Chart_Interface>>();
  Procssing:boolean=false


  constructor(
    private Chart_Service:ChartService,
    private Alertify_Service:AlertifyService,
    private modalService: BsModalService
  ) { }




  ngOnInit() {
  }


  OnGet_Change_Action(input: Chart_Interface) {
    input.childVisible=!input.childVisible
    var IsItDelete:boolean=false
    for (let item of this.Selected_Chart)
    {
      if (input.id == item.id)
      {
        var temp = this.Selected_Chart.indexOf(item)
        this.Selected_Chart.splice(temp, 1)
        IsItDelete=true
        break;
      }
    }

    if (IsItDelete == false)
      this.Selected_Chart.push(input)

      this.On_Get_Selected_Tag.emit(this.Selected_Chart);
  }

}
